import "angular";
import "angular-resource";
//Controller
import EDeliveryDisplayController from "./EDeliveryDisplayController";
import EDeliveryEditController from "./EDeliveryEditController";
import EDeliveryInlineController from "./EDeliveryInlineController";
//Directive
import EDeliveryDirective from "./EDeliveryDirective";
import EDeliveryInlineDirective from "./EDeliveryInlineDirective";
//Factory
import EDeliveryFactory from "./EDeliveryFactory";
import EDeliveryService from "./EDeliveryService";
import EmailDirectiveModule from "../directive/email/EmailDirective";

var moduleName = "EDeliveryModule";

const EDeliveryModule = angular
    .module(moduleName, ["ngResource", EmailDirectiveModule.name])
    .controller("EDeliveryDisplayController", EDeliveryDisplayController)
    .controller("EDeliveryEditController", EDeliveryEditController)
    .controller("EDeliveryInlineController", EDeliveryInlineController)
    .factory("EDeliveryFactory", EDeliveryFactory)
    .service("EDeliveryService", EDeliveryService)
    .directive("eDelivery", EDeliveryDirective)
    .directive("eDeliveryInline", EDeliveryInlineDirective);
export default EDeliveryModule;
